<template>
  <v-card flat>
    <v-card-text>
      <h1 class="my-3">Customer Profile</h1>
      <h2 class="my-3">Create Profile</h2>
      <p>
        Create an account to access your booking history, and make changes to your upcoming bookings.
      </p>
      <v-container>
        <v-layout row v-if="loadingUser === true">
          <v-spacer></v-spacer>
          <v-flex class="loading pa-4" shrink>
            <pulse-loader :loading="loadingUser" class="pa-4 ma-4"></pulse-loader>
          </v-flex>
          <v-spacer></v-spacer>
        </v-layout>
        <v-layout v-else column>
          <v-flex>
            <v-text-field
              label="FIRST NAME (REQUIRED)"
              :rules="[rules.required, rules.minText]"
              v-model="user.name_first"
              :value="user.name_first"
              @input="validateContactInfo(user)"
              required
              outline
            ></v-text-field>
          </v-flex>
          <v-flex>
            <v-text-field
              label="LAST NAME (REQUIRED)"
              :rules="[rules.required, rules.minText]"
              v-model="user.name_last"
              :value="user.name_last"
              @input="validateContactInfo(user)"
              required
              outline
            ></v-text-field>
          </v-flex>
          <v-flex>
            <v-text-field
              label="CELL PHONE (REQUIRED)"
              v-model="user.phone.cell"
              :value="user.phone.cell"
              @input="validateContactInfo(user)"
              :rules="[rules.required, rules.minText, rules.phone]"
              type="phone"
              required
              outline
            ></v-text-field>
          </v-flex>
          <v-flex>
            <v-text-field
              label="ALTERNATE PHONE"
              v-model="user.phone.alt"
              :value="user.phone.alt"
              type="phone"
              outline
            ></v-text-field>
          </v-flex>
          <v-flex>
            <v-text-field
              label="EMAIL ADDRESS (REQUIRED)"
              v-model="user.email"
              :value="user.email"
              @input="validateContactInfo(user)"
              :rules="[rules.required, rules.minText, rules.email]"
              type="email"
              required
              outline
            ></v-text-field>
          </v-flex>
          <v-flex :class="messageClass">
            <v-text-field
              label="Password (REQUIRED)"
              v-model="password"
              type="password"
              :rules="[rules.required]"
              required
              outline
            ></v-text-field>
          </v-flex>
          <v-flex align-center>
            <v-layout row>
              <v-spacer></v-spacer>
              <v-flex shrink>
                <v-btn @click="cancelCreateAccount()" class="accent_light">
                  CANCEL
                </v-btn>
              </v-flex>
              <v-flex shrink>
                <v-btn @click="createAccount()" class="accent">
                  CREATE PROFILE
                </v-btn>
              </v-flex>
              <v-spacer></v-spacer>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import Shared from "@/mixins/Shared";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";

export default {
  name: "NewUser",
  mixins: [Shared],
  components: {PulseLoader}
}
</script>
